import React, { useState } from 'react';
import { FileText, Eye, Download } from 'lucide-react';
import PDFModal from '../components/PDFModal';
import './Catalogos.css';

// PDFs ya referenciados en data/ksb.js y data/tecnal.js — sin duplicar archivos.
const proveedores = [
  {
    id: 'ksb',
    nombre: 'KSB',
    logo: '/assets/logos/KSB-LOGO.webp',
    descripcion: 'Bombas, válvulas y sistemas de control para agua, industria y energía.',
    catalogos: [
      { nombre: 'Catálogo de Bombas', url: '/assets/ksb/KSB - Catálogo de Bombas.pdf' },
      { nombre: 'Catálogo Comercial de Válvulas', url: '/assets/ksb/KSB - Catálogo Comercial de Válvulas.pdf' },
      { nombre: 'Catálogo Técnico de Válvulas', url: '/assets/ksb/KSB - Catálogo Técnico de Válvulas.pdf' },
      { nombre: 'Sistemas de Presurización — Hyamat', url: '/assets/ksb/KSB Hyamat - Sistemas de Presurización.pdf' },
      { nombre: 'Monitoreo — KSB Guard', url: '/assets/ksb/KSB Guard - Monitoreo.pdf' },
    ],
  },
  {
    id: 'tecnal',
    nombre: 'TECNAL',
    logo: '/assets/logos/TECNAL-2026-LOGO.webp',
    descripcion: 'Equipos para plantas aceiteras, almacenamiento de granos y procesamiento industrial.',
    catalogos: [
      { nombre: 'Quebrador', url: '/assets/tecnal/pdfs/TECNAL_CRACKER-online.pdf' },
      { nombre: 'Laminador', url: '/assets/tecnal/pdfs/TECNAL_FLAKERS_online.pdf' },
      { nombre: 'Expander', url: '/assets/tecnal/pdfs/TECNAL_EXPANDER-online.pdf' },
      { nombre: 'Extractor rotativo', url: '/assets/tecnal/pdfs/TECNAL_Extrator-DT-online.pdf' },
      { nombre: 'DT - DTDC', url: '/assets/tecnal/pdfs/TECNAL_Extrator-DT-online.pdf' },
      { nombre: 'Secadora vertical', url: '/assets/tecnal/pdfs/TECNAL_SECADORA.pdf' },
    ],
  },
];

const Catalogos = () => {
  const [pdfModal, setPdfModal] = useState(null);

  return (
    <div className="catalogos-container">
      {/* Hero */}
      <section className="catalogos-hero">
        <div className="catalogos-hero-content">
          <h1 className="catalogos-hero-title">Catálogos técnicos</h1>
          <p className="catalogos-hero-subtitle">
            Documentación técnica y comercial de nuestras representaciones,
            disponible para consulta y descarga.
          </p>
        </div>
      </section>

      {/* Catálogos por proveedor */}
      <section className="catalogos-content-section">
        <div className="container">
          {proveedores.map((prov) => (
            <div key={prov.id} className="catalogos-proveedor">
              <div className="catalogos-proveedor-header">
                <img
                  src={prov.logo}
                  alt={`Logo ${prov.nombre}`}
                  className="catalogos-proveedor-logo"
                  loading="lazy"
                />
                <div className="catalogos-proveedor-info">
                  <h2 className="catalogos-proveedor-nombre">{prov.nombre}</h2>
                  <p className="catalogos-proveedor-desc">{prov.descripcion}</p>
                </div>
              </div>

              <ul className="catalogos-lista">
                {prov.catalogos.map((cat) => (
                  <li key={cat.url} className="catalogos-row">
                    <div className="catalogos-row-name">
                      <FileText size={20} className="catalogos-row-icon" />
                      <span>{cat.nombre}</span>
                    </div>
                    <div className="catalogos-row-actions">
                      <button
                        className="catalogos-btn catalogos-btn--view"
                        onClick={() => setPdfModal({
                          url: cat.url,
                          title: `${prov.nombre} — ${cat.nombre}`,
                        })}
                      >
                        <Eye size={16} />
                        Ver PDF
                      </button>
                      <a
                        href={cat.url}
                        download
                        className="catalogos-btn catalogos-btn--download"
                      >
                        <Download size={16} />
                        Descargar
                      </a>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {pdfModal && (
        <PDFModal
          pdfUrl={pdfModal.url}
          title={pdfModal.title}
          onClose={() => setPdfModal(null)}
        />
      )}
    </div>
  );
};

export default Catalogos;
